var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedhairGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-35.5 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "006-Redhair") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-737.000000, -523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006-Redhair",
    transform: "translate(737.000000, 523.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2773,102.9376 L24.7523,103.6626 C24.7523,103.6626 26.3833,106.5056 26.1643,108.0606 C25.9463,109.6156 19.1843,113.6696 15.7393,113.3946 C12.2953,113.1206 12.0813,109.9806 12.3253,108.7316 C12.5693,107.4816 19.2773,102.9376 19.2773,102.9376",
    id: "Fill-668",
    fill: "#EEA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8859,112.0843 C18.1509,112.3443 25.1599,108.5793 26.0699,106.8623 C26.1689,107.2953 26.2139,107.7103 26.1649,108.0603 C25.9459,109.6153 19.1839,113.6693 15.7399,113.3953 C13.8519,113.2443 12.9359,112.2333 12.5319,111.1443 C13.0619,111.6383 13.8179,111.9993 14.8859,112.0843",
    id: "Fill-670",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.255,104.6411 C25.636,105.3971 26.07,106.8621 26.07,106.8621 C25.732,107.6451 23.852,108.8081 23.852,108.8081 C22.789,106.2031 25.255,104.6411 25.255,104.6411",
    id: "Fill-672",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4697,106.4815 C16.9487,108.9265 16.2997,111.9995 16.2997,111.9995 L15.9097,113.4015 C15.8527,113.3995 15.7947,113.3995 15.7397,113.3955 C12.2947,113.1205 12.0817,109.9805 12.3257,108.7315 C12.4127,108.2835 13.3297,107.4135 14.4697,106.4815",
    id: "Fill-674",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7151,104.0288 C17.7151,104.0288 20.4341,106.3038 20.4341,106.7248 C20.4341,107.1458 19.3671,108.1728 18.7881,108.1728 C18.2081,108.1728 15.8761,105.3778 15.8761,105.3778 C16.4701,104.0678 17.7151,104.0288 17.7151,104.0288",
    id: "Fill-676",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5059,100.7057 L23.3879,100.7097 C23.3879,100.7097 24.2519,100.7147 24.7699,101.1107 C25.2879,101.5067 25.4279,103.0007 24.6349,103.7927 C23.8429,104.5857 21.8129,104.8987 20.7999,104.4027 C19.3669,103.7017 18.8179,102.2997 19.0929,101.5677 C19.4579,100.5927 20.5059,100.7057 20.5059,100.7057",
    id: "Fill-678",
    fill: "#D47087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6128,107.9609 C36.8508,107.3009 32.4228,106.3089 31.5898,107.8159 C30.6848,109.4509 30.9408,118.2579 32.5868,119.9949 C34.2328,121.7329 40.2258,120.3689 40.6378,118.1279 C41.0488,115.8879 38.3748,108.6209 37.6128,107.9609",
    id: "Fill-680",
    fill: "#EEA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6932,110.9695 C37.4332,110.7255 33.5312,111.7085 33.3482,112.0555 C33.1652,112.4025 33.3482,113.5775 33.6532,113.7125 C33.9582,113.8485 37.9052,112.9155 38.0122,112.6155 C38.1192,112.3155 37.9532,111.2135 37.6932,110.9695",
    id: "Fill-682",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3723,106.077 C36.8233,105.391 35.8923,105.326 35.8923,105.326 L32.6603,105.509 C32.6603,105.509 31.8703,105.822 31.2913,106.702 C30.8493,107.373 31.2273,109.11 32.4343,109.872 C33.6403,110.634 36.2243,110.38 37.0513,109.193 C38.0533,107.755 37.6533,106.428 37.3723,106.077",
    id: "Fill-684",
    fill: "#D47087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3005,70.6908 C26.3005,70.6908 31.8545,105.6578 32.7695,106.8538 C33.6835,108.0508 35.8485,107.5858 36.1225,106.5188 C36.3965,105.4518 38.8735,71.1908 38.8735,71.1908 L26.3005,70.6908 Z",
    id: "Fill-686",
    fill: "#5C4555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.155,76.0095 C18.155,76.0095 20.77,101.0845 20.913,101.4005 C21.218,102.0725 23.581,102.1395 24.045,101.3925 C24.864,100.0705 26.962,79.1485 26.962,79.1485 L18.155,76.0095 Z",
    id: "Fill-688",
    fill: "#5C4555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8508,29.6124 C42.8508,29.6124 51.6898,33.7904 49.7488,42.2944 C48.5658,47.4744 41.4198,46.6844 41.4198,46.6844 C41.4198,46.6844 48.1968,51.7574 46.2878,56.5234 C44.3788,61.2904 32.5058,56.1284 32.5058,56.1284 L26.9618,45.7954 L42.8508,29.6124 Z",
    id: "Fill-690",
    fill: "#C66853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8722,24.4678 C16.8722,24.4678 7.7612,31.4268 9.0942,36.0388 C10.4272,40.6508 16.9242,41.4208 16.9242,41.4208 C16.9242,41.4208 11.5262,46.6118 13.4352,51.3788 C15.3442,56.1458 24.4482,56.1458 24.4482,56.1458 L32.7612,40.6508 L16.8722,24.4678 Z",
    id: "Fill-692",
    fill: "#C66853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9239,56.5658 L12.7359,62.1908 C12.7359,62.1908 18.2649,55.7178 18.7419,55.5678 C19.4419,55.3458 21.5309,57.9188 21.5309,57.9188 C21.5309,57.9188 14.0879,67.8898 12.5059,67.8898 C10.9239,67.8898 4.7629,59.6908 4.7629,59.6908 L7.9239,56.5658 Z",
    id: "Fill-694",
    fill: "#F3B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6477,46.6826 L21.5307,57.9196 C18.6217,56.5026 18.3947,55.0236 18.5847,54.3026 C19.6657,50.2006 25.6477,46.6826 25.6477,46.6826",
    id: "Fill-696",
    fill: "#EEA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7422,55.5673 C19.2942,55.3933 20.7052,56.9513 21.2792,57.6203 L20.8882,58.6863 C20.8362,58.7483 20.7842,58.8103 20.7262,58.8793 C18.9182,57.9823 18.1732,57.0653 17.9202,56.3333 C18.3252,55.8963 18.6262,55.6043 18.7422,55.5673",
    id: "Fill-698",
    fill: "#D58F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5306,57.9193 C18.6216,56.5023 18.3946,55.0233 18.5846,54.3023 C18.6806,53.9383 18.8186,53.5753 18.9866,53.2153 C19.8286,54.7273 21.0936,55.7693 22.0836,56.4083 L21.5306,57.9193 Z",
    id: "Fill-700",
    fill: "#A0698D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9621,79.1487 L18.1551,76.0097 C18.1551,76.0097 18.5031,79.3357 18.8801,82.9217 C20.6961,84.3427 23.2201,85.3397 26.2651,85.7427 C26.6541,82.1917 26.9621,79.1487 26.9621,79.1487",
    id: "Fill-702",
    fill: "#463141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7872,85.9171 C32.1942,85.8651 35.6372,85.0271 37.9272,84.0841 C38.4312,77.2991 38.8742,71.1911 38.8742,71.1911 L26.3002,70.6911 C26.3002,70.6911 27.4752,78.0641 28.7872,85.9171",
    id: "Fill-704",
    fill: "#463141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4286,43.8611 C39.7126,43.6981 41.3426,80.7441 39.7126,81.7671 C37.5896,83.0991 31.3726,85.1051 26.3006,84.4351 C21.2106,83.7631 17.2676,80.4091 16.3766,78.5791 C15.0966,75.9521 20.8506,44.0291 30.4286,43.8611",
    id: "Fill-706",
    fill: "#C57FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5126,47.6859 C33.5126,47.6859 31.1096,50.4839 28.4696,49.9869 C25.8106,49.4869 26.3446,46.4219 26.3446,46.4219 L33.5126,47.6859 Z",
    id: "Fill-708",
    fill: "#A0698D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.032,46.601 C33.032,46.601 30.983,49.934 28.47,48.987 C26.471,48.234 27.164,45.322 27.164,45.322 L33.032,46.601 Z",
    id: "Fill-710",
    fill: "#EFA26E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3431,38.0884 C19.4661,46.6874 33.6711,48.9964 37.3971,47.0304 C42.5111,44.3334 45.1341,35.4634 45.1341,35.4634 L20.2701,13.4374 C20.2701,13.4374 14.3921,32.7154 16.3431,38.0884",
    id: "Fill-712",
    fill: "#F3B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5858,43.6985 C32.5858,42.4755 33.4118,41.4835 34.4318,41.4835 C35.4508,41.4835 36.2778,42.4755 36.2778,43.6985 C36.2778,44.9215 35.4508,45.9135 34.4318,45.9135 C33.4118,45.9135 32.5858,44.9215 32.5858,43.6985",
    id: "Fill-714",
    fill: "#EB8E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4749,62.7151 C35.8129,62.1701 38.6649,61.3661 39.2709,61.8061 C39.8769,62.2451 43.7549,78.8391 43.7549,78.8391 C43.7549,78.8391 46.2989,80.5591 45.9379,84.0021 C45.7069,86.2061 43.9069,87.2671 42.1169,87.5661 C40.3279,87.8641 40.7089,82.9551 40.7089,82.9551 C40.7089,82.9551 40.1149,83.2611 39.0299,83.2831 C37.9439,83.3051 36.9789,82.6861 37.0909,82.0891 C37.2019,81.4931 40.1009,79.8081 40.1009,79.8081 C40.1009,79.8081 35.1369,63.2601 35.4749,62.7151",
    id: "Fill-716",
    fill: "#F3B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6074,49.114 C37.0804,49.79 42.1694,59.598 40.9954,61.014 C40.4404,61.684 35.0294,63.103 34.0974,62.73 C33.1654,62.357 31.9184,53.092 32.5854,50.925 C33.2534,48.757 35.6074,49.114 35.6074,49.114",
    id: "Fill-718",
    fill: "#EEA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4749,62.7151 C35.8129,62.1701 38.6649,61.3661 39.2709,61.8061 C39.3579,61.8681 39.5129,62.2701 39.7119,62.8981 C38.5599,63.3131 36.8939,63.7421 35.6469,63.9331 C35.4949,63.2431 35.4239,62.7971 35.4749,62.7151",
    id: "Fill-720",
    fill: "#D58F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0322,59.3203 C41.2142,60.1233 41.2282,60.7333 40.9962,61.0143 C40.4412,61.6843 35.0292,63.1023 34.0972,62.7293 C33.9052,62.6533 33.7072,62.0953 33.5132,61.2573 C35.2172,61.1753 39.6652,60.0013 41.0322,59.3203",
    id: "Fill-722",
    fill: "#A0698D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5566,37.1241 C44.5566,37.1241 47.1886,36.9981 47.6856,38.8571 C48.0586,40.2561 47.5466,42.5911 46.1296,43.2311 C44.7126,43.8701 42.0176,42.3251 42.0176,42.3251 L44.5566,37.1241 Z",
    id: "Fill-724",
    fill: "#F3B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2874,30.7097 C22.4084,30.5927 28.8754,26.3087 28.8754,26.3087 C28.8754,26.3087 29.1814,30.5217 30.5244,31.2507 C32.9654,32.5747 37.1124,31.2507 37.1124,31.2507 L40.7204,20.7507 L18.3624,20.1817 C18.3624,20.1817 17.2844,23.1257 16.2874,30.7097",
    id: "Fill-726",
    fill: "#D58F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6467,18.493 C14.6467,18.493 9.3757,13.963 11.0267,10.719 C12.6777,7.476 20.0867,9.882 20.0867,9.882 C20.0867,9.882 17.6127,4.091 21.0867,1.144 C23.2377,-0.681 33.3227,9.081 33.3227,9.081 C33.3227,9.081 35.9367,2.071 37.5067,2.593 C42.6267,4.294 42.3477,14.353 42.3477,14.353 C42.3477,14.353 48.4237,16.691 48.4237,21.316 C48.4237,24.404 44.1527,21.945 44.1527,21.945 C44.1527,21.945 45.9777,27.142 45.9827,32.129 C45.9877,37.19 43.2817,38.773 41.1697,37.816 C36.9757,35.916 36.7837,28.744 36.7837,28.744 C36.7837,28.744 33.2637,29.915 31.8227,29.408 C30.3817,28.9 30.6697,22.778 30.6697,22.778 C30.6697,22.778 19.3017,31.583 12.4297,28.422 C5.5577,25.26 14.6467,18.493 14.6467,18.493",
    id: "Fill-728",
    fill: "#E4785D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.771,27.0385 C49.786,27.0305 49.801,27.0235 49.815,27.0145 C49.801,27.0235 49.786,27.0305 49.771,27.0385",
    id: "Fill-732",
    fill: "#D9A45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0862,1.1439 C23.2372,-0.6811 33.3232,9.0809 33.3232,9.0809 C33.3232,9.0809 35.9362,2.0709 37.5072,2.5929 C42.6262,4.2939 42.3482,14.3529 42.3482,14.3529 C42.3482,14.3529 41.5662,9.9289 36.4472,8.2269 C34.8762,7.7049 33.6582,12.2389 33.6582,12.2389 C33.6582,12.2389 24.9242,4.4449 22.3512,5.5999 C20.2152,6.5589 20.0862,9.8819 20.0862,9.8819 C20.0862,9.8819 17.6132,4.0909 21.0862,1.1439",
    id: "Fill-736",
    fill: "#C66853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1843,56.0866 C9.3523,56.5386 9.9593,55.0986 10.0153,54.4696 C10.0713,53.8416 8.9363,52.0106 8.3543,51.9156 C7.7723,51.8196 6.0353,51.8666 5.9183,52.9216 C5.8013,53.9766 7.0163,55.6346 8.1843,56.0866",
    id: "Fill-748",
    fill: "#D58F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3354,44.4829 C2.9704,44.0939 7.5514,43.7669 8.0944,44.1939 C8.3634,44.4059 11.1014,47.9389 11.1084,48.5639 C11.1224,49.9409 6.5954,50.1249 6.3144,50.2939 C5.7694,50.6209 1.0974,51.2299 0.7674,50.5719 C0.4364,49.9139 1.7004,44.8719 2.3354,44.4829",
    id: "Fill-750",
    fill: "#C27D78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0671,49.6642 C-0.0169,47.9962 2.0841,44.4952 2.3351,44.4832 C2.5861,44.4702 5.3201,48.7762 5.3201,48.7762 L3.0831,54.0272 C3.0831,54.0272 0.0831,49.9822 0.0671,49.6642",
    id: "Fill-752",
    fill: "#9A5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3201,48.7762 C5.9551,48.3872 10.7511,47.8792 11.0791,48.4872 C11.4071,49.0952 9.1751,53.4222 8.6301,53.7492 C8.0861,54.0762 3.4141,54.6852 3.0831,54.0272 C2.7531,53.3692 4.6851,49.1652 5.3201,48.7762",
    id: "Fill-754",
    fill: "#9A5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5159,49.9569 C2.3399,49.5269 0.4999,52.5089 0.2509,53.8469 C0.0009,55.1859 2.9179,59.2639 3.8069,59.8729 C4.6969,60.4809 8.4559,58.0289 8.5529,56.9719 C8.6499,55.9149 4.6919,50.3869 3.5159,49.9569",
    id: "Fill-756",
    fill: "#F3B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5594,116.3201 C36.8024,114.5051 32.7744,116.7881 31.7304,118.0681 C31.9564,118.9331 32.2394,119.6271 32.5874,119.9951 C34.2334,121.7321 40.2254,120.3681 40.6374,118.1281 C40.7174,117.6901 40.6774,117.0561 40.5594,116.3201",
    id: "Fill-758",
    fill: "#FEFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2263,36.3906 C29.5133,35.8186 27.4323,37.3416 28.0093,38.0766 C28.7153,38.9756 29.7663,37.3646 30.7053,37.6936 C31.7213,38.0486 31.7123,40.2326 32.8093,39.8516 C33.6573,39.5566 32.9593,36.9696 31.2263,36.3906",
    id: "Fill-760",
    fill: "#050000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9954,32.5813 C19.2824,32.0093 17.2014,33.5323 17.7784,34.2673 C18.4844,35.1663 19.5354,33.5553 20.4744,33.8843 C21.4904,34.2393 21.4814,36.4233 22.5784,36.0423 C23.4264,35.7473 22.7284,33.1603 20.9954,32.5813",
    id: "Fill-762",
    fill: "#050000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedhairGirl);
export default __webpack_public_path__ + "static/media/redhair-girl.d7e9e3c7986e9bc1bd0305f83681e1cb.svg";
export { ForwardRef as ReactComponent };